import PubSub from "underpub-js";
import gsap from "gsap";

var CardInfo = function (options) {
    this.options = {
        $el: false,
        baseClass: "el-CardInfo",
    };

    $.extend(true, this.options, options);
};

CardInfo.prototype.init = function () {
    var self = this;
    self.$image = self.options.$el.find(`.${self.options.baseClass}__image`);
    self.$content = self.options.$el.find(`.${self.options.baseClass}__content`);
    self.$button = self.options.$el.find(`.${self.options.baseClass}__button`);
    // self.initAnimation();

    // invalidate timeline on resize so that height values update
    PubSub.subscribe("Sitewide:resized", function () {
        self.hoverAnimationTl.invalidate();
    });
};
CardInfo.prototype.initAnimation = function () {
    var self = this;
    if (self.$image.length == 0 || self.$content.length == 0 || self.$button.length == 0) return;
    self.hoverAnimationTl = gsap
        .timeline({
            paused: true,
            defaults: {
                duration: 0.5,
                ease: "power3.out",
            },
        })
        .set(self.$button, {
            clearProps: "display,opacity",
        })
        .set(self.$content, {
            clearProps: "height",
        })
        .set(self.$content, {
            height: function () {
                return self.$content.outerHeight();
            }, // passing a function here, which will make GSAP re-evaluate this when invalidate() is called
        })
        .set(self.$image, {
            scale: 1.3,
        })
        .set(self.$button, {
            display: "block",
        })

        .to(self.$content, {
            height: "auto",
        })
        .to(
            self.$image,
            {
                scale: 1,
            },
            "<"
        )
        .to(
            self.$button,
            {
                opacity: 1,
            },
            "<"
        );

    self.options.$el
        .on("mouseenter", self.options.$el, function () {
            self.hoverAnimationTl.play();
        })
        .on("mouseleave", self.options.$el, function () {
            self.hoverAnimationTl.reverse();
        });
};

export default CardInfo;
